import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchUserCreditsWallet } from '../../api/creditsService';

import { creditsKeys } from './keys';

export const creditsWalletOptions = () =>
	queryOptions({
		queryKey: creditsKeys.wallet(),
		queryFn: async () => {
			const { data, error } = await fetchUserCreditsWallet();
			if (error) throw error;
			return data ?? null;
		},
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
	});

export function useCreditsWallet() {
	return useQuery(creditsWalletOptions());
}
